export enum TagColor {
  Green = 'green',
  Red = 'red',
  Orange = 'orange',
  Blue = 'blue',
  Purple = 'purple',
  Yellow = 'yellow',
  Cyan = 'cyan',
  Black = 'black',
  Grey = 'grey',
}

export enum TagAppearance {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
}

export enum TagSize {
  XS = 'xs',
  S = 's',
  M = 'm',
  L = 'l',
}
